import * as React from "react";
const SvgFiRrScaleComparison = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-scale-comparison_svg__a)">
      <path
        fill="#062147"
        d="M19 8h1.374c1.25 0 2.395-.86 2.593-2.094a2.48 2.48 0 0 0-.868-2.312c.264-.386.414-.855.4-1.36C22.463.966 21.33 0 20.06 0H19a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1m.6-6.4h.6a.7.7 0 0 1 0 1.4h-.6zm0 3h.9c.496 0 .9.404.9.9s-.404.9-.9.9h-.9zM1.778 10.999c.365 0 .68-.254.76-.61l.174-.79h2.38l.16.765a.799.799 0 0 0 1.564-.329L5.68 4.626c-.135-.668-.523-1.213-1.035-1.459a1.602 1.602 0 0 0-1.534.057c-.47.277-.809.776-.926 1.356L1.02 10.059a.777.777 0 0 0 .76.939zm1.974-6.103c.03-.149.105-.253.176-.296l.017.006c.024.016.121.118.168.349l.641 3.044H3.066zm19.07 4.62-22 4A1 1 0 0 0 .997 15.5c.06 0 9.668-1.741 9.668-1.741l-2.562 7.167c-.229.788-.084 1.633.388 2.261.39.518.96.814 1.565.814h3.883c.606 0 1.177-.296 1.565-.814.472-.627.617-1.473.37-2.319l-2.706-7.563 10.008-1.82a1 1 0 0 0-.357-1.968zM13.942 22l-3.82.015c-.058-.039-.174-.263-.114-.475l1.993-5.572 1.975 5.514c.078.271-.039.494-.034.518"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-scale-comparison_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrScaleComparison;
